
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 .49A24.51 24.51 0 1049.51 25 24.53 24.53 0 0025 .49zM12.46 39.08a2 2 0 112-2 2 2 0 01-2 2zm4.85-4.86a2 2 0 112-2 2 2 0 01-2 2zm4.86-4.86a2 2 0 112-2 2 2 0 01-2 2zM27 24.5a2 2 0 112-2 2 2 0 01-2 2zm4.86-4.86a2 2 0 112-2 2 2 0 01-1.97 2zM37.54 15a2 2 0 112-2 2 2 0 01-2 2z","fill":"var(--primary-highlight)"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/infraFill.svg